import { format, isValid, parse } from 'date-fns'

const ISO_DATE_FORMAT = 'yyyy-MM-dd'
const BT50_DATE_FORMAT = 'M/d/yyyy'
const US_DISPLAY_FORMAT = 'MM/dd/yyyy'

const ISO_DATE_PREFIX = /^(\d{4}-\d{2}-\d{2})/

/**
 * Parses a calendar date string (ISO date, BillTrack50 M/d/yyyy, or Payload date) in local time.
 * Avoids UTC midnight shifting for `YYYY-MM-DD` values.
 */
export function parseCalendarDateString(value: string): Date | null {
  const trimmed = value.trim()
  if (!trimmed) {
    return null
  }

  const isoMatch = ISO_DATE_PREFIX.exec(trimmed)
  if (isoMatch) {
    const date = parse(isoMatch[1], ISO_DATE_FORMAT, new Date())
    return isValid(date) ? date : null
  }

  const slashDate = parse(trimmed, BT50_DATE_FORMAT, new Date())
  if (isValid(slashDate)) {
    return slashDate
  }

  const fallback = new Date(trimmed)
  return isValid(fallback) ? fallback : null
}

/**
 * Formats a calendar date for US locale display (MM/DD/YYYY).
 */
export function dateToLocaleString(date: string | Date): string {
  if (typeof date === 'string') {
    const parsed = parseCalendarDateString(date)
    if (parsed) {
      return format(parsed, US_DISPLAY_FORMAT)
    }
    return date
  }

  return format(date, US_DISPLAY_FORMAT)
}
